// extracted by mini-css-extract-plugin
export var actionButton = "_a2-0";
export var attachmentLine = "_a2-1";
export var fileInput = "_a2-2";
export var fileUploadWrapper = "_a2-4";
export var footer = "_a2-3";
export var modalContent = "_a2-5";
export var paperclip = "_a2-6";
export var quillEditor = "_a2-7";